import { axiosInstance } from "../../../axios/axiosInstance";

const API_SYSTEM_SETTINGS_URL = "admin/system-settings";
const API_UPDATE_SERVICE_PROVIDER_REFERRAL_CODE_MODULE_URL = API_SYSTEM_SETTINGS_URL + "/update_organization_referral_program";
const API_UPDATE_CUSTOMER_REFERRAL_CODE_MODULE_URL = API_SYSTEM_SETTINGS_URL + "/update_customer_referral_program";

export const updateServiceProviderReferralCode = (dataToBeSent) => {
  return axiosInstance.post(API_UPDATE_SERVICE_PROVIDER_REFERRAL_CODE_MODULE_URL, dataToBeSent);
};
export const updateCustomerReferralCode = (dataToBeSent) => {
  return axiosInstance.post(API_UPDATE_CUSTOMER_REFERRAL_CODE_MODULE_URL, dataToBeSent);
};



